import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ReportStatusConstants } from 'src/app/common/Constants/LabelConstants';
import { REPORT_STATUS_TYPE } from 'src/app/common/Constants/enums';
import { CustomerActivitiesDialogComponent } from 'src/app/pages/customers/customer-activities-dialog/customer-activities-dialog.component';

@Component({
    selector: 'app-report-status',
    templateUrl: './report-status.component.html',
    styleUrls: ['./report-status.component.scss'],
    standalone: false
})
export class ReportStatusComponent {
  LabelConstants: any = {};
  imageSrc: any = ''
  name: any = ''
  reportType: any;
  reportedName: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private dialog: MatDialog) {
    this.reportType = data.reportType;
    this.imageSrc = data.imageSrc
    this.name = data.name;
    this.reportedName = data.reportedName;
  }

  ngOnInit(): void {
    this.LabelConstants = ReportStatusConstants
  }

  public get getReportStatusType(): typeof REPORT_STATUS_TYPE {
    return REPORT_STATUS_TYPE;
  }

  closeModal(bool: any) {
    if (bool) {
      if (this.reportedName.sessionId > 0) {
        this.dialog.closeAll();
        const dialogRef = this.dialog.open(CustomerActivitiesDialogComponent, {
          width: '930px',
          data: {},
          disableClose: true,
          autoFocus: false
        });
        dialogRef.componentInstance.customerId = this.reportedName.customerId;
        dialogRef.componentInstance.isReported = true;
      }
      else {
        this.dialog.closeAll();
      }
    }
    else {
      this.dialog.closeAll();
    }
  }
}
